import { Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, NavigationEnd, Event, NavigationStart } from "@angular/router";
import { Subscription } from "rxjs";
import { MediaChange, MediaObserver } from "@angular/flex-layout";
import PerfectScrollbar from "perfect-scrollbar";
import { TourService } from "ngx-tour-ng-bootstrap";
import { filter } from "rxjs/operators";
import { MenuItems } from "../core/menu/menu-items/menu-items";
import { PageTitleService } from "../core/page-title/page-title.service";
import { AuthService } from "../service/auth/auth.service";
import { CoreService } from "../service/core/core-service.service";
import { AfterContentChecked } from "@angular/core";
import { GlobalService } from "app/shared/global.service";
import { CommonService } from "app/shared/common.service";
import { CustomizeService } from "app/shared/customize.service";
import { DashboardV1Service } from "app/dashboard/dashboard-v1/dashboard-v1.service";
import { DatePipe } from "@angular/common";
import { ToastrService } from 'ngx-toastr';
import { BookingLoginComponent } from "app/session/booking-login/booking-login.component";

declare var require;

const screenfull = require("screenfull");

@Component({
  selector: "epion-layout",
  templateUrl: "./main-material.html",
  styleUrls: ["./main-material.scss"],
  encapsulation: ViewEncapsulation.None
})

export class MainComponent implements OnInit, OnDestroy, AfterContentChecked {

  datePipe = new DatePipe('en-US');
  dark: boolean;
  boxed: boolean;
  collapseSidebar: boolean;
  compactSidebar: boolean;
  customizerIn: boolean = false;
  chatWindowOpen: boolean = false;
  chatSidebar: boolean = false;
  sidebarClosed: boolean = false;
  chatpanelOpen: boolean = false;
  sidenavOpen: boolean = true;
  isMobile: boolean = false;
  isFullscreen: boolean = false;
  _opened: boolean = true;
  _showBackdrop: boolean = false;
  _closeOnClickOutside: boolean = false;
  showSettings: boolean = false;

  image: "assets/img/user-3.jpg";

  _mode: string = "push";
  sidenavMode: string = "side";
  themeSkinColor: any = "light";
  headerSkinColor: any = "light";
  root: any = "ltr";
  layout: any = "ltr";
  header: string;
  url: string;
  public innerWidth: any;
  input: any;
  miniSidebar: boolean = true;
  private _router: Subscription;
  private _mediaSubscription: Subscription;

  isExpiry = false;
  LicenseValidUpTo = new Date(this.globals.CurrentDateTime);
  currentDate = new Date();
  //isRateChange = false;

  itemToEditPageHit = {
    'PageUrl': '',
    'HitDate': new Date(),
    'HitCount': 1,
    'UserIP': '',
  };

  currentLang = "en";
  @ViewChild("sidenav") sidenav;

  constructor(public tourService: TourService,
    private coreService: CoreService,
    private authService: AuthService,
    public menuItems: MenuItems,
    private pageTitleService: PageTitleService,
    public translate: TranslateService,
    private router: Router,
    private media: MediaObserver,
    private cdr: ChangeDetectorRef,
    public globals: GlobalService,
    private dashboardV1Service: DashboardV1Service,
    private commonService: CommonService,
    private toasterService: ToastrService,
    private customizeService: CustomizeService) {

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : "en");

  }

  public HasClientDetails(): boolean {
    return this.globals != null && this.globals.ClientID > 0;
  }

  // Getting Client Details using AuthService
  GetClientDetails() {
    const tokenInfo = this.authService.getDecodedToken();
    this.globals.ClientID = tokenInfo["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];
    this.globals.LocationID = tokenInfo["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/locality"];
    this.globals.LoginTemplate = tokenInfo["role"];
    this.globals.UserID = tokenInfo["nameid"];
    this.globals.UserName = tokenInfo["unique_name"].toLowerCase();
    this.globals.IsDocterzClient = tokenInfo["actort"] == "True" ? true : false;
    this.globals.DefaultStore = tokenInfo["DefaultStore"];
    this.globals.DefaultSubStore = tokenInfo["DefaultSubStore"];
    this.globals.LicenseFor = tokenInfo["LicenseFor"];
    this.globals.HospitalBelongsTo = tokenInfo["HospitalBelongsTo"];
    this.globals.IsClientSuperAdmin = tokenInfo["IsClientAdmin"] == "True" ? true : false;
    this.globals.IsDiangnosticDeleteAuthority = tokenInfo["DiangnosticDeleteAuthority"] == "True" ? true : false;
    this.globals.MultiClientLocation = tokenInfo["MultiClientLocation"] == "True" ? true : false;

    const date = new Date(0);
    this.globals.ExpireTime = new Date(date.setUTCSeconds(tokenInfo["exp"]));

    this.GetAuthentcationsForUserByUserId();
    this.globals.HasClientInfo = true;
  }

  // Getting Atuhentications For User
  GetAuthentcationsForUserByUserId() {
    this.commonService.GetMenuVisbleForUserByUserID(this.globals.UserID)
      .subscribe((data) => {
        this.globals.MenuComponentAuthentication = data;
        this.GetGeneralConfigurationDetails();
        this.GetConfigurationDetails();
        this.GetClientConfigurationDetails();
      });
  }

  // Getting Configuration Details
  GetConfigurationDetails() {
    this.commonService.GetConfigurationDetails(this.globals.ClientID, this.globals.LocationID)
      .subscribe((data) => {
        if (data.length > 0) {
          this.globals.configurations = data[0];
          this.loadClientReceiptBooks();
          this.GetClientLicenseValidUpTo();
        }
        this.menuItems.updateMenuItems(this.globals.UserID);
        this.loadMessages();

      });
  }

  // Getting General Configuration Details
  GetGeneralConfigurationDetails() {
    this.commonService.GetGeneralConfigurationDetails()
      .subscribe((data) => {
        if (data.length > 0) {
          this.globals.GeneralConfigurations = data[0];
          console.log(this.globals.GeneralConfigurations);
        }
      });
  }

  // Getting company Configuration Details
  GetClientConfigurationDetails() {
    this.commonService.GetClientConfigurationDetails(this.globals.ClientID, this.globals.LocationID)
      .subscribe((data) => {
        if (data.length > 0) {
          this.globals.configurationsDetails = data;
        }
      });
  }

  // this function is used to show subscription expiry message to client before 15 days from date of expiry
  GetClientLicenseValidUpTo() {
    this.LicenseValidUpTo = this.globals.configurations["LicenseValidUpTo"];
    let date = new Date(this.LicenseValidUpTo);
    let currentDate = new Date();
    let days = Math.floor((date.getTime() - currentDate.getTime()) / 1000 / 60 / 60 / 24);
    if (days < 15) {
      this.isExpiry = true;
    }
  }

  // Setting Receipt Book Details
  loadClientReceiptBooks() {
    if (this.globals.configurations) {
      // For OPD
      const opdList = this.globals.configurations["OPD"] != undefined
        && this.globals.configurations["OPD"] != "" ? this.globals.configurations["OPD"].split(",") : "";
      if (opdList.length > 0) {
        this.globals.OPDCash = +opdList[0];
        this.globals.OPDCashSettlement = +opdList[1];
        this.globals.OPDInvoice = +opdList[2];
        this.globals.OPDInvoiceSettlement = +opdList[3];
        this.globals.OPDAdvance = +opdList[4];
        this.globals.OPDRefundBill = +opdList[5];
        this.globals.OPDRefundAdvance = +opdList[6];
        this.globals.OPDCashlessDummyBill = +opdList[7];
      }

      // For IPD
      const ipdList = this.globals.configurations["IPD"] != undefined
        && this.globals.configurations["IPD"] != "" ? this.globals.configurations["IPD"].split(",") : "";
      if (ipdList.length > 0) {
        this.globals.IPDCash = +ipdList[0];
        this.globals.IPDCashSettlement = +ipdList[1];
        this.globals.IPDInvoice = +ipdList[2];
        this.globals.IPDInvoiceSettlement = +ipdList[3];
        this.globals.IPDAdvance = +ipdList[4];
        this.globals.IPDRefundBill = +ipdList[5];
        this.globals.IPDRefundAdvance = +ipdList[6];
        this.globals.IPDShortBill = +ipdList[7];
        this.globals.IPDShortBillSettlement = +ipdList[8];
        this.globals.IPDCashlessDummyBill = +ipdList[9];
      }

      // For Sales
      const salesList = this.globals.configurations["Sales"] != undefined
        && this.globals.configurations["Sales"] != "" ? this.globals.configurations["Sales"].split(",") : "";
      if (salesList.length > 0) {
        // Sales
        this.globals.SalesCash = +salesList[0];
        this.globals.SalesInvoice = +salesList[1];
        this.globals.SalesBillSettlement = +salesList[2];
        this.globals.SalesReturn = +salesList[3];
        this.globals.SalesRefund = +salesList[4];
      }

      // For GRN
      const grnList = this.globals.configurations["GRN"] != undefined
        && this.globals.configurations["GRN"] != "" ? this.globals.configurations["GRN"].split(",") : "";
      if (grnList.length > 0) {
        // GRN
        this.globals.GoodsReceiptNote = +grnList[0];
        this.globals.GoodsReceiptNoteReturn = +grnList[1];
      }

      // For Indent
      const indentList = this.globals.configurations["Indent"] != undefined
        && this.globals.configurations["Indent"] != "" ? this.globals.configurations["Indent"].split(",") : "";
      if (grnList.length > 0) {
        // Indent
        this.globals.Indent = +indentList[0];
        this.globals.AllowNewIndentWOoldIndent = +indentList[1];
      }

      // For Material Issue
      const MaterialIssueList = this.globals.configurations["SubStore"] != undefined
        && this.globals.configurations["SubStore"] != "" ? this.globals.configurations["SubStore"].split(",") : "";
      if (MaterialIssueList.length > 0) {
        // Indent
        this.globals.MaterialIssue = +MaterialIssueList[0];
        this.globals.ReturnFromSubStore = +MaterialIssueList[1];
      }

      // For Material Concusme
      const MaterialConsumeList = this.globals.configurations["MaterialConsume"]
        && this.globals.configurations["MaterialConsume"] != "" ? this.globals.configurations["MaterialConsume"].split(",") : "";
      if (MaterialConsumeList.length > 0) {
        // Material Concusme
        this.globals.MaterialConsume = +MaterialConsumeList[0];
      }

      // For StockAdjustment and MrpAdjustment
      const StockAdjustmentList = this.globals.configurations["StockAdjustment"]
        && this.globals.configurations["StockAdjustment"] != "" ? this.globals.configurations["StockAdjustment"].split(",") : "";
      if (StockAdjustmentList.length > 0) {
        // StockAdjustment
        this.globals.StockAdjustment = +StockAdjustmentList[0];
        // MrpAdjustment
        this.globals.MrpAdjustment = +StockAdjustmentList[1];
      }



    }
  }


  // This method is used to display cutomized messages.
  // This method gives call to getMessages function from customizeService
  loadMessages() {
    this.customizeService.getMessages().subscribe((data) => {
      this.globals.messages = data;

      this.SetComponentVisible();
    });
  }

  // Sets Component Visibility
  SetComponentVisible() {
    for (let i = 0; i < this.globals.MenuComponentAuthentication.length; i++) {
      const ComponentName = this.globals.MenuComponentAuthentication[i]["ComponentName"];
      this.globals.VisibleComponentMenu[ComponentName] = {
        "ComponentID": this.globals.MenuComponentAuthentication[i]["ComponentID"],
        "AuthenticationType": this.globals.MenuComponentAuthentication[i]["AuthenticationType"]
      };
    }

    // Setting Component Visible Not In Menu
    this.SetComponentVisibleNotInMenu();
  }

  // Setting Component Visible Not In Menu
  SetComponentVisibleNotInMenu() {

    /* OPD And IPD Both */
    // Registration
    if (this.globals.VisibleComponentMenu["registration"]) {
      this.globals.registrationVisible = true;
    }
    // Admission
    if (this.globals.VisibleComponentMenu["admission"]) {
      this.globals.admissionVisible = true;
    }
    // Visit-mark
    if (this.globals.VisibleComponentMenu["visit-mark"]) {
      this.globals.visitMarkVisible = true;
    }
    // Case Paper
    if (this.globals.VisibleComponentMenu["case-paper"]) {
      this.globals.casePaperVisible = true;
    }

    // Nursing Observation
    if (this.globals.VisibleComponentMenu["nursing-observation"]) {
      this.globals.nursingObservationVisible = true;
    }

    // IPD Refund
    if (this.globals.VisibleComponentMenu["ipd-refund"]) {
      this.globals.IpdrefundVisible = true;
    }

    // OPD Refund
    if (this.globals.VisibleComponentMenu["opd-refund"]) {
      this.globals.OpdrefundVisible = true;
    }

    // Cashless
    if (this.globals.VisibleComponentMenu["cashless"]) {
      this.globals.cashlessVisible = true;
      // this.globals.imageuploadVisible = true;
    }

    // Cashless Dummy Bill
    if (this.globals.VisibleComponentMenu["cashless-dummy-bill"]) {
      this.globals.cashlessDummyBillVisible = true;
    }

    // Pathology Result Entry
    if (this.globals.VisibleComponentMenu["pathology-result-entry"]) {
      this.globals.pathologyResultEntryVisible = true;
    }

    // file upload
    if (this.globals.VisibleComponentMenu["image-upload"]) {
      this.globals.imageuploadVisible = true;
    }

    // Doctor Request
    if (this.globals.VisibleComponentMenu["doctor-request"]) {
      this.globals.doctorRequestVisible = true;
    }

    // package-charges
    if (this.globals.VisibleComponentMenu["package-charges"]) {
      this.globals.packageChargesVisible = true;
    }

    // pharmacy bill updation
    if (this.globals.VisibleComponentMenu["pharmacy-bill-updation"]) {
      this.globals.pharmacyBillUpdationVisible = true;
    }

    /* OPD */

    // Bill
    if (this.globals.VisibleComponentMenu["bill"]) {
      this.globals.billVisible = true;
    }

    // OPD Advance
    if (this.globals.VisibleComponentMenu["opd-advance"]) {
      this.globals.OpdadvanceVisible = true;
    }

    // Session data
    if (this.globals.VisibleComponentMenu["session-data"]) {
      this.globals.SessionDatavisible = true;
    }

    // Ipd Bill Reconciliation
    if (this.globals.VisibleComponentMenu["opd-bill-reconciliation"]) {
      this.globals.opdBillReconciliationVisible = true;
    }

    /* IPD */

    // Bill
    if (this.globals.VisibleComponentMenu["ipd-bill"]) {
      this.globals.ipdBillVisible = true;
    }

    // IPD Advance
    if (this.globals.VisibleComponentMenu["ipd-advance"]) {
      this.globals.IpdadvanceVisible = true;
    }

    // Payment
    if (this.globals.VisibleComponentMenu["ipd-bill-payment"]) {
      this.globals.ipdBillPaymentVisible = true;
    }

    // Discharge
    if (this.globals.VisibleComponentMenu["discharge"]) {
      this.globals.dischargeVisible = true;
    }

    // Bed Transfer
    if (this.globals.VisibleComponentMenu["bed-transfer"]) {
      this.globals.bedTransferVisible = true;
    }

    // IPD Short Bill
    if (this.globals.VisibleComponentMenu["ipd-short-bill"]) {
      this.globals.ipdShortBillVisible = true;
    }

    // pathology Result Entry
    if (this.globals.VisibleComponentMenu["pathology-result-entry"]) {
      this.globals.pathologyResultEntryVisible = true;
    }

    // radiology Result Entry
    if (this.globals.VisibleComponentMenu["radiology-result-entry"]) {
      this.globals.radiologyResultEntryVisible = true;
    }

    // Ipd Bill Reconciliation
    if (this.globals.VisibleComponentMenu["ipd-bill-reconciliation"]) {
      this.globals.ipdBillReconciliationVisible = true;
    }

    // Sales Return
    if (this.globals.VisibleComponentMenu["sales-return"]) {
      this.globals.salesRetunVisible = true;
    }


    // Pharmacy Bill Reconciliation
    if (this.globals.VisibleComponentMenu["pharmacy-bill-reconciliation"]) {
      this.globals.pharmacyBillRecoVisible = true;
    }
    // Goods Receipt Note Return
    if (this.globals.VisibleComponentMenu["goods-receipt-note-return"]) {
      this.globals.goodsReceiptNoteRetunVisible = true;
    }

    // Return From Sub Store Return
    if (this.globals.VisibleComponentMenu["return-from-sub-store"]) {
      this.globals.returnFromSubStoreReturnVisible = true;
    }

    // External Pathology Billing
    if (this.globals.VisibleComponentMenu["external-pathology-billing"]) {
      this.globals.externalPathologyBillingVisible = true;
    }

    // Lupin Pathology Report
    if (this.globals.VisibleComponentMenu["pathology-report"]) {
      this.globals.pathologyReportVisible = true;
    }

    // OPD Report
    if (this.globals.VisibleComponentMenu["opd-reports"]) {
      this.globals.opdReportVisible = true;
    }
    // IPD Report
    if (this.globals.VisibleComponentMenu["ipd-reports"]) {
      this.globals.ipdReportVisible = true;
    }
    // Common Report
    if (this.globals.VisibleComponentMenu["common-reports"]) {
      this.globals.commonReportVisible = true;
    }
    // Inventory Report
    if (this.globals.VisibleComponentMenu["inventory-reports"]) {
      this.globals.inventoryReportVisible = true;
    }
    // patient prescription
    if (this.globals.VisibleComponentMenu["patient-prescription"]) {
      this.globals.patientPrescriptonVisible = true;
    }
    // stock adjustment
    if (this.globals.VisibleComponentMenu["stock-adjustment"]) {
      this.globals.stockAdjustmentVisible = true;
    }

    // Mrp adjustment
    if (this.globals.VisibleComponentMenu["mrp-adjustment"]) {
      this.globals.MrpAdjustmentVisible = true;
    }

    // Payment Reconciliation
    if (this.globals.VisibleComponentMenu["payment-reconciliation"]) {
      this.globals.PaymentReconciliationVisible = true;
    }
    // Vaccination
    if (this.globals.VisibleComponentMenu["vaccination"]) {
      this.globals.VaccinationVisible = true;
    }
    // Paediatric CaseSheet
    if (this.globals.VisibleComponentMenu["paediatric-casesheet"]) {
      this.globals.PaediatricCaseSheetVisible = true;
    }
    // change-password
    if (this.globals.VisibleComponentMenu["change-password"]) {
      this.globals.ChangePasswordVisible = true;
    }
  }

  private allowedRoutes = ['/session/forgot-password', '/session/about',
    '/session/therapies', '/session/facilities', '/session/tariff/tariff', '/session/tariff/cancelationpolicy', '/session/home',
    '/session/booking', '/session/gallery', '/session/dincharya']; // Allowed routes without logout  '/session/booking-login',

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.pageTitleService.title.subscribe((val: string) => {
      this.header = val;
    });
    // this.customizeService.getMessages().subscribe((data) => {
    //   //this.globals.messages = data;
    // });
    let isHome = true;
    this.router.events.subscribe(event => {
      isHome = false;
      if (event instanceof NavigationEnd) {
        // 1️⃣ Check if the route is in the allowed list directly
        if (this.allowedRoutes.includes(event.url)) {
          if (this.globals.UserName != '') {
            this.logOut();
          }
          return;
        }
        // 2️⃣ Extract unique parent routes dynamically (e.g., "/session/about", "/session/therapies")
        const parentRoutes = this.allowedRoutes
          .filter(route => route.split('/').length === 3) // Only get parent routes
          .map(route => route.split('/').slice(0, 3).join('/') + '/'); // Extract "/session/about", "/session/therapies", etc.

        // 3️⃣ Check if the route starts with any allowed parent route (for child paths)
        const isAllowed = parentRoutes.some(parent => event.url.startsWith(parent));
        if (isAllowed && this.globals.UserName != '') {
          this.logOut();
        }
        if (event.url == '/') {
          // Navigate again programmatically
          this.router.navigateByUrl('/session/home').then(() => {
            this.itemToEditPageHit = {
              'PageUrl': '/session/home',
              'HitDate': new Date(),
              'HitCount': 1,
              'UserIP': '',
            }
            this.commonService.pageHitCount(this.itemToEditPageHit).subscribe(() => {
            });
            // Then hide the route from the URL
            history.replaceState({}, '', '/');
          });
        }
        else if (event.url == '/session/booking/booking' || event.url == '/session/booking-login/booking-login') {
          this.itemToEditPageHit = {
            'PageUrl': event.url,
            'HitDate': new Date(),
            'HitCount': 1,
            'UserIP': '',
          }
          this.commonService.pageHitCount(this.itemToEditPageHit).subscribe((data) => {
          });
        }
      }


    });
    // let currentDate = new Date();
    // let UptoDate = new Date('2026-08-15');
    // if (currentDate < UptoDate) {
    //   this.isRateChange = true;
    // }
    if (isHome) {
      this.itemToEditPageHit = {
        'PageUrl': '/session/home',
        'HitDate': new Date(),
        'HitCount': 1,
        'UserIP': '',
      }
      this.commonService.pageHitCount(this.itemToEditPageHit).subscribe(() => {
      });
    }

    // this._router = this.router.events.pipe(
    //   filter((event: Event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
    //     this.url = event.url;

    //     if (document.querySelector("#sideNavMenu > aside").classList.contains("ng-sidebar--opened")) {
    //       document.getElementById("toggleButton").click();
    //     }
    //   });

    // if (this.url != "/session/login" && this.url != "/session/register"
    //   && this.url != "/session/forgot-password" && this.url != "/session/lockscreen") {
    //   const elemSidebar = <HTMLElement>document.querySelector(".sidebar-container");

    //   /** Perfect scrollbar for sidebar menu **/
    //   if (window.matchMedia(`(min-width: 1280px)`).matches) {
    //     const ps = new PerfectScrollbar(elemSidebar, {
    //       wheelSpeed: 2,
    //       wheelPropagation: true,
    //       minScrollbarLength: 20
    //     });
    //     ps.update();
    //   }

    //   /** Perfect scrollbar for chat window **/
    //   const elemChatbar = <HTMLElement>document.querySelector(".chat-inner ");
    //   if (window.matchMedia(`(min-width: 1280px)`).matches) {
    //   }

    //   this._toggleOpened();
    // }

    // if (this.media.isActive("xs") || this.media.isActive("sm") || this.media.isActive("md")) {
    //   this._mode = "over";
    //   this._closeOnClickOutside = true;
    //   this._showBackdrop = true;
    //   this._opened = false;
    //   this.sidebarClosed = false;
    // }

    // this._mediaSubscription = this.media.media$.subscribe((change: MediaChange) => {
    //   const isMobile = (change.mqAlias == "xs") || (change.mqAlias == "sm") || (change.mqAlias == "md");

    //   this.isMobile = isMobile;
    //   this._mode = (isMobile) ? "over" : "push";
    //   this._closeOnClickOutside = (isMobile) ? true : false;
    //   this._showBackdrop = (isMobile) ? true : false;
    //   this._opened = !isMobile;
    //   this.sidebarClosed = false;
    // });


    // // Add class on focus of search box in header
    // document.getElementById("search-field").addEventListener("focusin", function () {
    //   document.getElementById("search-field").parentElement.classList.add("search-active");
    // });

    // document.getElementById("search-field").addEventListener("focusout", function () {
    //   document.getElementById("search-field").parentElement.classList.remove("search-active");
    // });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const content = document.querySelector('.main-content'); // Adjust this selector
      if (content) {
        content.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  GetDashboardpage() {
    this.router.navigate(['/dashboard']);
  }

  ngOnDestroy() {
    this._router.unsubscribe();
    this._mediaSubscription.unsubscribe();
  }

  /**
    * toggleFullscreen method is used to show a template in fullscreen.
    */
  toggleFullscreen() {
    if (screenfull.enabled) {
      screenfull.toggle();
      this.isFullscreen = !this.isFullscreen;
    }
  }

  /**
    * _toggleOpened method is used to toggle a menu list.
    */
  public _toggleOpened() {
    this._opened = !this._opened;
    this.sidebarClosed = !this.sidebarClosed;
  }

  /**
    * customizerFunction is used to open and close the customizer.
    */
  customizerFunction() {
    this.customizerIn = !this.customizerIn;
  }

  /**
    * chatWindowFunction is used to open and close the chat window.
    */
  chatWindowFunction() {
    this.chatWindowOpen = !this.chatWindowOpen;
  }

  /**
    * chatSidebarFunction is used to open and close the chat sidebar list.
    */
  chatSidebarFunction() {
    this.chatSidebar = !this.chatSidebar;
  }

  /**
    * changeThemeColor function filter the color for sidebar section.
    */
  changeThemeColor(color) {
    this.themeSkinColor = color;
  }

  /**
    * changeHeaderColor function filter the color for header section.
    */
  changeHeaderColor(color) {
    this.headerSkinColor = color;
  }

  /**
    * As router outlet will emit an activate event any time a new component is being instantiated.
    */
  onActivate(scrollContainer) {
    scrollContainer.scrollTop = 0;
  }

  /**
    * changeRTL method is used to change the layout of template.
    */
  changeRTL(isChecked) {
    if (isChecked) {
      this.layout = "rtl";
      this.coreService.rtlShowStatus = true;
    } else {
      this.layout = "ltr";
      this.coreService.rtlShowStatus = false;
    }
  }

  /**
    * toggleSidebar method is used to switch between Icon sidebar and Sidebar.
    */
  toggleSidebar(isChecked) {
    this.miniSidebar = !isChecked;
    if (isChecked) {
      document.getElementById("showSidebar").classList.remove("icon-sidebar");
      document.getElementsByClassName("app")[0].classList.remove("icon-sidebar-wrap");
      document.getElementById("boxed-layout").classList.remove("disabled-checkbox");
    } else {
      document.getElementById("showSidebar").className += " icon-sidebar";
      document.getElementsByClassName("app")[0].className += " icon-sidebar-wrap";
      document.getElementById("boxed-layout").className += " disabled-checkbox";
    }
  }

  /**
    * logOut method is used to log out the  template.
    */
  logOut() {
    this.globals.UserName = '';
    this.globals.UserID = 0;
    this.globals.UserEmail = '';
    this.authService.logOut();
  }

  /**
    *closeOnClickOutside method is used when click on outside close/open the sidebar.
    */
  closeOnClickOutside() {
    if (this._opened) {
      this.sidebarClosed = false;
    } else {
      this.sidebarClosed = true;
    }
    return this._closeOnClickOutside;
  }

  /**
    * boxedLayout method is used to show the box layout.
    */
  boxedLayout(isChecked) {
    if (isChecked) {
      this.boxed = true;
      document.getElementById("icon-sidebar").className += " disabled-checkbox";
    } else {
      this.boxed = false;
      document.getElementById("icon-sidebar").classList.remove("disabled-checkbox");
    }
  }

  // GetUserUpdateDetails() {
  //   this.globals.IsUserDetailsUpdate = true
  //   this.bookingLoginComponent.GetUserDetails();
  // }

  goHome() {
    // Navigate again programmatically
    this.router.navigateByUrl('/session/home').then(() => {
      // Then hide the route from the URL
      history.replaceState({}, '', '/');
    });
  }

  LogOut() {
    this.authService.logOut();
    debugger
    this.globals.UserName = '';
    this.globals.UserEmail = '';
    this.globals.UserID = 0;
    this.router.navigate(['/session/booking/booking']);
    setTimeout(() => {
      this.router.navigate(['/session/booking-login/booking-login-register']);
    }, 500);
  }
}
